import React, { useState } from 'react';
import './OfficerCard.css';

const OfficerCard = ({ image, name, title, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="officer-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Officer Image with optional overlay */}
      <div className="image-container">
        <img src={image} alt={name} className="officer-card-image" />
        {isHovered && (
          <ul className="officer-card-description">
            {description.map((item, index) => {
              const [label, value] = item.split(' - ');
              return (
                <li key={index}>
                  <strong>{label}</strong> - {value}
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* Officer Info */}
      <h3 className="officer-card-name">{name}</h3>
      <p className="officer-card-title">{title}</p>
    </div>
  );
};

export default OfficerCard;
